<div class="grid-form-control" [class.required]="form?.controls[this.entry.formControlAttributes?.formControlName]?.invalid">
  <form [formGroup]="form">
    <input matInput
        #entryRef
        type="text"
        [formControlName]="entry?.formControlAttributes?.formControlName"
        [name]="entry?.formControlAttributes?.formControlName"
        readonly
      />
  </form>
</div>